import React, { useEffect, useRef, useState } from "react";
import classes from "./Community.module.css";
import BackgroundLayout from "../Components/BackgroundLayout";
import NavbarMobile from "../Components/NavbarMobile";
import Navbar from "../Components/Navbar";
import BottomNavbar from "../Components/BottomNavbar";
import PostModal from "../Components/PostModal";
import { useAppDispatch, useAppSelector } from "../Store/hooks";
import { togglePostModal } from "../Slices/postModalSlice";
import Background from "../Components/Background";
import {
  useFetchPostsMutation,
  useGetCommentsMutation,
  useGetUserLikedPostsMutation,
  useLikePostMutation,
  usePostCommentMutation,
} from "../Slices/httpSlice";
import { toast } from "react-toastify";
import SkeletonCardsGrid from "../Components/SkeletonCardsGrid";
import { motion } from "framer-motion";
import SearchModal from "../Components/SearchModal";
import WatchlistModal from "../Components/WatchlistModal";
import UserRatingsModal from "../Components/UserRatingsModal";
import ProfileModal from "../Components/ProfileModal";
import Drawer from "../Components/Drawer";
import { InputText } from "primereact/inputtext";
import moment from "moment-timezone";
import Spinner from "../Components/Loaders/Spinner";
import { useNavigate } from "react-router-dom";

const Community = () => {
  const lastItemRef = useRef<HTMLDivElement | null>(null);
  const [fetchData, setFetchData] = useState<boolean>(true);
  const [communityPosts, setCommunityPosts] = useState<any[]>([]);
  const [userLikedPosts, setUserLikedPosts] = useState<any>([]);

  const { user } = useAppSelector((state) => state.userSlice);

  const dispatch = useAppDispatch();
  const navigate=useNavigate();
  const handleAddPostClick = () => {
    if (!user) {
      toast.info(
        "Oops! Please signin or signup to share your thoughts in community!"
      );
      navigate("/");
    } else {
      dispatch(togglePostModal());
    }
  };

  const [fetchPostsApi, { isLoading }] = useFetchPostsMutation();
  const [getCommentsApi, { isLoading: commentsLoading }] =
    useGetCommentsMutation();
  const [postCommentApi, { isLoading: postCommentLoading }] =
    usePostCommentMutation();

  // const [getUserLikedPostsApi, { isLoading: getUserLikedPostsLoading }] =
  //   useGetUserLikedPostsMutation();

  // const fetchUserLikedPosts = async () => {
  //   const response: any = await getUserLikedPostsApi({
  //     body: {
  //       userId: user?.id,
  //     },
  //     token: user?.token,
  //   });
  //   console.log(response, "r");
  //   if (response?.error) {
  //     console.log(response.error, "error");
  //     toast.error(
  //       response?.error?.data?.error?.error ||
  //         response?.error?.data?.error ||
  //         response?.error?.data ||
  //         response?.error?.message ||
  //         "Something Went Wrong!"
  //     );
  //   } else {
  //     setUserLikedPosts(response?.data?.result);
  //   }
  // };

  // useEffect(() => {
  //   if (user) {
  //     fetchUserLikedPosts();
  //   }
  // }, [user]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && fetchData && !isLoading) {
          fetchPosts();
        }
      },
      { threshold: 1.0 }
    );

    if (lastItemRef.current) {
      observer.observe(lastItemRef.current);
    }

    return () => {
      if (lastItemRef.current) {
        observer.unobserve(lastItemRef.current);
      }
    };
  }, [fetchData, isLoading]);

  const fetchPosts = async () => {
    const response: any = await fetchPostsApi({
      body: {
        skip: communityPosts.length > 0 ? communityPosts : false,
        userId: user?.id,
      },
    });
    console.log(response, "r");
    if (response?.error) {
      setFetchData(false);
      console.log(response.error, "error");
      toast.error(
        response?.error?.data?.error?.error ||
          response?.error?.data?.error ||
          response?.error?.data ||
          response?.error?.message ||
          "Something Went Wrong!"
      );
    } else {
      if (response?.data?.result?.result.length === 0) {
        setFetchData(false);
        return;
      }
      if (communityPosts.length > 0 && user) {
        let posts = [...communityPosts, ...response?.data?.result?.result];
        const updatedCommunityPosts = posts.map((post) => {
          const isLiked = response?.data?.result?.userLikedPosts.some(
            (dataItem: any) => dataItem?.postId === post.id
          );
          return {
            ...post,
            userLiked: isLiked ? 1 : 0,
          };
        });
        setCommunityPosts(updatedCommunityPosts);
        setUserLikedPosts(response?.data?.result?.userLikedPosts);
      } else if (user) {
        let posts = response?.data?.result?.result;
        const updatedCommunityPosts = posts.map((post: any) => {
          const isLiked = response?.data?.result?.userLikedPosts.some(
            (dataItem: any) => dataItem?.postId === post.id
          );
          return {
            ...post,
            userLiked: isLiked ? 1 : 0,
          };
        });
        setCommunityPosts(updatedCommunityPosts);
        setUserLikedPosts(response?.data?.result?.userLikedPosts);
      } else {
        setCommunityPosts((prevValue) =>
          prevValue.length > 0
            ? [...prevValue, ...response?.data?.result?.result]
            : response?.data?.result?.result
        );
      }
    }
  };

  console.log(communityPosts, "cp");

  const [showComments, setShowComments] = useState<boolean>(false);
  const [postId, setPostId] = useState<null | number>(null);
  const [commentOffset, setCommentOffset] = useState<number>(0);
  const [comments, setComments] = useState<any[]>([]);
  const [fetchCommentsData, setFetchCommentsData] = useState<boolean>(true);
  const [comment, setComment] = useState("");
  const commentItemRef = useRef<HTMLDivElement | null>(null);

  const handleOpenComments = (id: number) => {
    setComments([]);
    setCommentOffset(0);
    setShowComments(true);
    setPostId(id);
    setFetchCommentsData(true);
    fetchComments(id, 0);
  };

  const handleCloseComments = () => {
    setComments([]);
    setShowComments(false);
    setPostId(null);
    setFetchCommentsData(true);
    setCommentOffset(0);
  };

  const fetchComments = async (id: number, offsetParam?: number) => {
    const response: any = await getCommentsApi({
      body: {
        postId: id,
        offset: offsetParam ?? commentOffset,
      },
    });
    console.log(response, "r");
    if (response?.error) {
      console.log(response.error, "error");
      toast.error(
        response?.error?.data?.error?.error ||
          response?.error?.data?.error ||
          response?.error?.data ||
          response?.error?.message ||
          "Something Went Wrong!"
      );
    } else {
      if (response?.data?.result.length === 0) {
        setFetchCommentsData(false);
        return;
      }
      setComments((prevValue) =>
        prevValue.length > 0
          ? [...prevValue, ...response?.data?.result]
          : response?.data?.result
      );
      if (offsetParam) {
        setCommentOffset(offsetParam + 10);
      } else {
        setCommentOffset((prevValue) => prevValue + 10);
      }
    }
  };

  const postComment = async (e: any, id: number) => {
    e.preventDefault();
    if (comment.trim().length === 0) {
      toast.error("Please enter the comment!");
      return;
    }

    const response: any = await postCommentApi({
      body: {
        comment: comment,
        userId: user?.id,
        username: user?.username,
        postId: id,
      },
      token: user?.token,
    });
    console.log(response, "r");
    if (response?.error) {
      if (response?.error?.status === 403) {
        toast.error("Please Login Again, Token Expired!");
      } else {
        toast.error(
          "Something Went Wrong!" ||
            response?.error?.data?.error?.error ||
            response?.error?.data?.error ||
            response?.error?.data?.message ||
            response?.error?.message
        );
      }
    } else {
      fetchComments(id, 0);
      setComment("");
      // increasing the comments in the posts
      setCommunityPosts(
        communityPosts?.map((data) => {
          if (data?.id === id) {
            return { ...data, comments: data?.comments + 1 };
          } else {
            return { ...data };
          }
        })
      );
      toast.success("Comment Posted Successfully!");
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (
          entries[0].isIntersecting &&
          showComments &&
          fetchCommentsData &&
          !commentsLoading
        ) {
          fetchComments(postId!);
        }
      },
      { threshold: 1.0 }
    );

    if (commentItemRef.current) {
      observer.observe(commentItemRef.current);
    }

    return () => {
      if (commentItemRef.current) {
        observer.unobserve(commentItemRef.current);
      }
    };
  }, [showComments, fetchCommentsData, commentsLoading, commentItemRef]);

  const [likePostApi, { isLoading: likePostLoading }] = useLikePostMutation();

  const likeHandler = async (id: number) => {
    if (!user || user === null || user === undefined) {
      toast.error("Please Login to join the community and share the feedback!");
      return;
    }
    const response: any = await likePostApi({
      body: {
        userId: user?.id,
        username: user?.username,
        postId: id,
      },
      token: user?.token,
    });
    if (response?.error) {
      if (response?.error?.status === 403) {
        // toast.error("Please Login Again, Token Expired!");
        toast.error(
          "Please Login to join the community and share the feedback!"
        );
      } else {
        toast.error(
          "Something Went Wrong!" ||
            response?.error?.data?.error?.error ||
            response?.error?.data?.error ||
            response?.error?.data?.message ||
            response?.error?.message
        );
      }
    } else {
      console.log(response?.data?.result, "dd");
      if (response?.data?.result?.status === 0) {
        // user unliked the post..
        toast.warning("Post Unliked Successfully!");
        setCommunityPosts(
          communityPosts?.map((data) => {
            if (data?.id === id) {
              return { ...data, userLiked: 0, likes: data?.likes - 1 };
            } else {
              return { ...data };
            }
          })
        );
      } else {
        setCommunityPosts(
          communityPosts?.map((data) => {
            if (data?.id === id) {
              return { ...data, userLiked: 1, likes: data?.likes + 1 };
            } else {
              return { ...data };
            }
          })
        );
        toast.success("Post Liked Successfully!");
      }
    }
  };

  return (
    <>
      <BackgroundLayout paddingBottom={true}>
        {/* <Background> */}
        <NavbarMobile />
        <Navbar activeLink={4} />

        <div className={classes.category_title_container}>
          <div className={classes.title_container}>
            <p className={classes.category_title}>Top Posts</p>
          </div>
          <button
            className={classes.add_review_btn}
            onClick={handleAddPostClick}
          >
            <i className={`pi pi-plus ${classes.add_icon}`} />
            Add a Post
          </button>
        </div>

        <div className={classes.community_posts}>
          {communityPosts?.map((data, idx) => {
            return (
              <>
                <div className={classes.community}>
                  <div className={classes.community_header}>
                    <div className={classes.avatar_with_name}>
                      <div className={classes.avatar}>
                        <img src="/assets/images/avatar2.png" alt="avatar" />
                      </div>
                      <p className={classes.name}>{data?.username}</p>
                    </div>

                    <p className={classes.date_time}>
                      {moment(data?.date_time).fromNow()}
                    </p>
                  </div>

                  <div className={classes.images_section_container}>
                    <div
                      className={classes.images_section}
                      style={{
                        gridTemplateColumns: `repeat(${
                          // JSON.parse(data?.media).length
                          3
                        },109px)`,
                      }}
                    >
                      {JSON.parse(data?.media)?.map(
                        (media: any, idx2: number) => {
                          return (
                            <div className={classes.image} key={idx2}>
                              <img
                                src={process.env.REACT_APP_MEDIA_PATH_PREFIX?.replace(
                                  "<replace_media_id>",
                                  media?.poster_path
                                )}
                                alt=""
                                className={classes.img}
                              />
                            </div>
                          );
                        }
                      )}
                    </div>
                  </div>

                  <div className={classes.content_section}>
                    <p className={classes.title}>
                      {JSON.parse(data?.headline)}
                    </p>
                    <p
                      className={classes.description}
                      dangerouslySetInnerHTML={{
                        __html: JSON.parse(data?.description).replace(
                          /\n/g,
                          "<br />"
                        ),
                      }}
                    ></p>
                  </div>

                  <div className={classes.actions}>
                    <button
                      className={classes.action_wrapper}
                      type="button"
                      disabled={likePostLoading}
                      onClick={() => likeHandler(data?.id)}
                    >
                      {likePostLoading ? (
                        <Spinner theme="light" />
                      ) : data?.userLiked ? (
                        <>
                          <i
                            className={`pi pi-heart-fill ${classes.icon}`}
                            style={{ color: "red" }}
                          />
                          <p className={classes.action}>{data?.likes}</p>
                        </>
                      ) : (
                        <>
                          <i className={`pi pi-heart ${classes.icon}`} />
                          <p className={classes.action}>{data?.likes}</p>
                        </>
                      )}
                      {/* {data?.userLiked ? (
                        <i
                          className={`pi pi-heart-fill ${classes.icon}`}
                          style={{ color: "red" }}
                        />
                      ) : (
                        <i className={`pi pi-heart ${classes.icon}`} />
                      )} */}
                    </button>
                    <button
                      className={classes.action_wrapper}
                      type="button"
                      onClick={() =>
                        showComments && postId === data?.id
                          ? handleCloseComments()
                          : handleOpenComments(data?.id)
                      }
                    >
                      {showComments && postId === data?.id ? (
                        <i className={`pi pi-times ${classes.icon}`} />
                      ) : (
                        <>
                          <i className={`pi pi-comments ${classes.icon}`} />
                          <p className={classes.action}>{data?.comments}</p>
                        </>
                      )}
                    </button>
                  </div>

                  {showComments && postId === data?.id && (
                    <div className={classes.comments_section}>
                      <form
                        className={classes.write_comment}
                        onSubmit={(e) => postComment(e, data?.id)}
                      >
                        <InputText
                          type="text"
                          className={classes.comment_input}
                          placeholder="Write Comment"
                          value={comment}
                          onChange={(e) => setComment(e.target.value)}
                        />
                        <button type="submit" className={classes.send_btn}>
                          <i className={`pi pi-send ${classes.send_icon}`} />
                        </button>
                      </form>
                      <div className={classes.comments}>
                        {postCommentLoading ? (
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Spinner theme="light" />
                          </div>
                        ) : comments.length > 0 ? (
                          comments?.map((dataItem, index) => {
                            return (
                              <div
                                ref={
                                  comments.length - 1 === index
                                    ? commentItemRef
                                    : null
                                }
                                className={classes.comment_box}
                                key={index}
                              >
                                <div className={classes.avatar_with_comment}>
                                  <div className={classes.avatar}>
                                    <img
                                      src="/assets/images/avatar2.png"
                                      alt="avatar"
                                    />
                                  </div>
                                  <div className={classes.comment_content}>
                                    <p className={classes.commentor}>
                                      {dataItem?.username}{" "}
                                      <span className={classes.date}>
                                        {" "}
                                        {moment(dataItem?.datetime).fromNow()}
                                      </span>{" "}
                                    </p>
                                    <p className={classes.comment}>
                                      {JSON.parse(dataItem?.comment)}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <p
                            style={{
                              color: "#BFBFBF",
                              fontFamily: "Ubuntu,sans-serif",
                              fontSize: 15,
                            }}
                          >
                            No Comments Yet! Be the first to comment on this post!
                          </p>
                        )}
                        {commentsLoading && (
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Spinner theme="light" />
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </>
            );
          })}
        </div>
        {isLoading && fetchData && (
          <motion.div
            initial={{
              background:
                "linear-gradient(45deg,hsl(0deg 0% 14%) 0%,hsl(0deg 0% 14%) 20%,hsl(0deg 0% 14%) 29%,hsl(0deg 0% 14%) 36%,hsl(0deg 0% 14%) 43%,hsl(0deg 0% 14%) 50%,hsl(228deg 3% 12%) 57%,hsl(228deg 5% 11%) 64%,hsl(228deg 8% 9%) 71%,hsl(228deg 11% 8%) 80%,hsl(228deg 14% 7%) 100%)",
            }}
            animate={{
              background: [
                "linear-gradient(45deg, hsl(228deg 14% 7%) 0%, hsl(228deg 11% 8%) 20%, hsl(228deg 8% 9%) 29%, hsl(228deg 5% 11%) 36%, hsl(228deg 3% 12%) 43%, hsl(0deg 0% 14%) 50%, hsl(228deg 3% 12%) 57%, hsl(228deg 5% 11%) 64%, hsl(228deg 8% 9%) 71%, hsl(228deg 11% 8%) 80%, hsl(228deg 14% 7%) 100%)",
                "linear-gradient(45deg,hsl(0deg 0% 14%) 0%,hsl(0deg 0% 14%) 20%,hsl(0deg 0% 14%) 29%,hsl(0deg 0% 14%) 36%,hsl(0deg 0% 14%) 43%,hsl(0deg 0% 14%) 50%,hsl(228deg 3% 12%) 57%,hsl(228deg 5% 11%) 64%,hsl(228deg 8% 9%) 71%,hsl(228deg 11% 8%) 80%,hsl(228deg 14% 7%) 100%)",
                "linear-gradient(45deg,hsl(228deg 14% 7%) 0%,hsl(228deg 11% 8%) 20%,hsl(228deg 8% 9%) 29%,hsl(228deg 5% 11%) 36%,hsl(228deg 3% 12%) 43%,hsl(0deg 0% 14%) 50%,hsl(0deg 0% 14%) 57%,hsl(0deg 0% 14%) 64%,hsl(0deg 0% 14%) 71%,hsl(0deg 0% 14%) 80%,hsl(0deg 0% 14%) 100%)",
              ],
            }}
            transition={{
              duration: 2,
              repeatType: "mirror",
              repeat: Infinity,
              ease: "linear",
            }}
            className={classes.community}
            style={{
              marginTop: "-24px",
            }}
          ></motion.div>
        )}
        {!isLoading && fetchData && (
          <div ref={lastItemRef} className={classes.load_item}></div>
        )}

        {/* </Background> */}
      </BackgroundLayout>
      <PostModal fetchPosts={fetchPosts} />
      <BottomNavbar activeLink={5} />
      <SearchModal />
      <WatchlistModal />
      <UserRatingsModal />
      <ProfileModal />
      <Drawer />
    </>
  );
};

export default Community;
